
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.414 2L21 8.586V14h-2v-4h-6V4H5v10H3V2h11.414zM15 5.414V8h2.586L15 5.414zM4.133 22.018v-2.219h.17l1.216 2.219h1.845L5.995 19.68c.436-.124.77-.34 1.003-.65.232-.309.348-.673.348-1.092 0-.368-.085-.7-.255-.994a1.744 1.744 0 00-.76-.693C5.994 16.084 5.584 16 5.102 16H2.46v6.018h1.674zm.825-3.34h-.825V17.41h.825c.232 0 .407.057.523.17.116.113.174.27.174.468 0 .419-.232.628-.697.628zm4.316 3.34l.332-1.003h2.133l.331 1.003h1.768l-2.192-5.992h-1.93l-2.201 5.992h1.759zm2.049-2.261h-1.301l.655-1.955.646 1.955zm5.26 2.261l.833-3.715.832 3.715h2.075L21.725 16h-1.802l-.663 4.097L18.325 16h-1.828l-.926 4.097L14.908 16h-1.802l1.402 6.018h2.075z"}})])
          )
        }
      }
    